import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import { translate } from "react-i18next";
import GPWebBasket from "../../../components/gp-web-basket/gp-web-basket";
import GPWebPayment from "../../../components/gp-web-payment/gp-web-payment";
import "./gp-web-plans-checkout-page.css";
import { INIT_ADD_FREE_PAYMENT, INIT_BRAINTREE_3DSECURE, INIT_BRAINTREE_CLIENT, INIT_BRAINTREE_HOSTEDFIELDS, INIT_PAYMENT_GATEWAY, INIT_SESSION_CALL, REGISTRATION_PENDING, SEND_POST_MESSAGE, USER_PAYMENT_PROCESSING } from "../../../actions";
import backArrow from '../../../../media/back-arrow.svg'
import CONSTANTS from "../../../constants";

export class GPWebPlansCheckoutPage extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  componentDidMount() {
    this.props.handleAction(INIT_PAYMENT_GATEWAY)
  }

  componentDidUpdate(prevProps, prevState) {
    const self = this;

    if (!this.props.paymentGateway.braintreeClient && this.props.paymentGateway.client_token && (prevProps.paymentGateway.client_token !== this.props.paymentGateway.client_token)) {
        this.props.handleAction(INIT_BRAINTREE_CLIENT, this.props.paymentGateway.client_token);
    }

    if (!this.props.paymentGateway.braintree3DSecure && this.props.paymentGateway.braintreeClient) {
      this.props.handleAction(INIT_BRAINTREE_3DSECURE, this.props.paymentGateway.braintreeClient);
    }

    if (!this.props.paymentGateway.braintreeHostedFields && this.props.paymentGateway.braintreeClient) {
      this.props.handleAction(INIT_BRAINTREE_HOSTEDFIELDS, {client: this.props.paymentGateway.braintreeClient, clientOptions: {
        styles: {
          input: {
            'color': '#757575',
            'margin-bottom': '24px',
            'font-size': '16px',
            'font-weight': '400',
            'line-height': '19px',
            'outline': 'none',
          }
        },
        fields: {
          number: {
            container: '#txt-card-number'
          },
          cardholderName: {
            container: '#txt-name-on-card'
          },
          expirationDate: {
            container: '#txt-expiry-date',
            placeholder: 'MM / YY'
          },
          cvv: {
            container: '#txt-cvv'
          },
          postalCode: {
            container: '#txt-post-code'
          }
        }
      }});
    }

    if (this.props.auth.authData && (prevProps.auth.authData !== this.props.auth.authData)) {
      if (!this.props.auth.authData.hasAdFreeSubscription) {
        this.props.handleAction(INIT_SESSION_CALL, {accessToken: this.props.auth.authData.access_token})
      } else {
        this.props.handleAction(SEND_POST_MESSAGE, this.props.auth.authData)
        this.props.router.push(`/gp-web/plans-thank-you/${this.props.auth.authData.email}/${this.props.basket.totalPrice}/${this.props.basket.currencySymbol}`)
      }
    }

    if (this.props.session && prevProps.session && (this.props.session.customer !== prevProps.session.customer)) {
      this.setState({
        ...this.state,
        readyForCardVerification: true
      })
    }

    if (this.state.readyForCardVerification === true) {

      this.setState({
        ...this.state,
        readyForCardVerification: false
      })

      const threeDSecureParameters = {
        amount: this.state.paymentInfo.amount,
        nonce: this.state.paymentInfo.nonce,
        bin: this.state.paymentInfo.details.bin,
        collectDeviceData: true,
        email: this.state.paymentInfo.email,
        billingAddress: {
          givenName: this.state.paymentInfo.firstName,
          surname: this.state.paymentInfo.lastName,
        }
      }
      
      this.props.paymentGateway.braintree3DSecure.on('lookup-complete', function(data, next) {
        next();
      })

      this.props.paymentGateway.braintree3DSecure.on('customer-canceled', function() {
        this.setState({
          ...this.state,
          genericError: this.props.t('PAYMENT_AUTHORIZATION_FAILED')
        })
      }.bind(this))

      // verify card
      this.props.paymentGateway.braintree3DSecure.verifyCard(threeDSecureParameters).then(function(response) {
        this.props.paymentGateway.braintree3DSecure.off('lookup-complete')
        this.props.paymentGateway.braintree3DSecure.off('customer-canceled')

        if (response.threeDSecureInfo.status === 'authenticate_successful') {
          this.props.handleAction(INIT_ADD_FREE_PAYMENT, {apiKey: this.props.session.api_key, payment_method_nonce: response.nonce, replace_existing: true, mai: this.props.paymentGateway.mai})
        }

      }.bind(this)).catch(function(err) {
        this.props.paymentGateway.braintree3DSecure.off('lookup-complete')
        this.props.paymentGateway.braintree3DSecure.off('customer-canceled')

        if (err['name'] === 'BraintreeError' && err['code'].includes('_ERROR')) {
          this.setState({
            ...this.state,
            genericError: this.props.t('PAYMENT_AUTHORIZATION_FAILED')
          })
        }
        console.log(err);
      }.bind(this))
    }

    if (this.props.paymentGateway.adFreePayment && prevProps.paymentGateway && (this.props.paymentGateway.adFreePayment !== prevProps.paymentGateway.adFreePayment)) {
      const {error, errorMessage} = this.props.paymentGateway.adFreePayment;
      if (!error) {
        this.props.handleAction(SEND_POST_MESSAGE, {
          ...this.props.auth.authData,
          hasAdFreeSubscription: true
        })
        this.props.router.push(`/gp-web/plans-thank-you/${this.props.auth.authData.email}/${this.props.basket.totalPrice}/${this.props.basket.currencySymbol}`)
      } else {
        this.setState({
          ...this.state,
          genericError: this.props.t('PAYMENT_AUTHORIZATION_FAILED')
        })
      }
    }
  }

  paymentHandler = (payload) => {
    const {threedsecure, email, firstName, lastName, password} = payload;

    this.setState({
      ...this.state,
      paymentInfo: {
        ...threedsecure,
        email,
        firstName,
        lastName,
      },
      genericError: undefined
    });

    // if we already have the authData here, then we initialise the session 
    if (this.props.auth.authData) {
      this.props.handleAction(INIT_SESSION_CALL, {accessToken: this.props.auth.authData.access_token})
    } else {
      this.props.handleAction(REGISTRATION_PENDING, {
        email,
        password,
        firstName,
        lastName,
        terms: true,
        newsletter: false,
        isRedirectFlow: false,
      });
    }

  };

  onClickBack = (e) => {
    e.preventDefault();

    this.props.router.goBack();
  }

  render() {
    const { t } = this.props;

    return (
      <div className="ad-checkout-modal xs-py3 xs-col-12">
        {document.referrer &&
          <a href={document.referrer} className="back" onClick={this.onClickBack}>
            <img alt={t('BACK')} src={backArrow} />
            {t('BACK')}
          </a>
        }

        <GPWebBasket {...this.props}/>
        <GPWebPayment {...this.props} genericError={this.state.genericError} paymentHandler={this.paymentHandler} />
      </div>
    );
  }
}

GPWebPlansCheckoutPage.propTypes = {
  t: PropTypes.func.isRequired,
};

GPWebPlansCheckoutPage.defaultProps = {};

const mapStateToProps = (state) => {
  return {
    basket: {
      totalPrice: 2,
      currencySymbol: CONSTANTS.CURRENCY_SYMBOL
    },
    paymentGateway: state.paymentGateway,
    registration: state.registration,
    auth: state.auth,
    session: state.session.session,
    adFreePayment: state.adFreePayment,
  }
}

const mapDispatchToProps = (dispatch) => ({
  handleAction: (type, payload) => dispatch({ type, payload }),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(translate()(GPWebPlansCheckoutPage));



// WEBPACK FOOTER //
// ./src/containers/pages/gp-web-plans-checkout/gp-web-plans-checkout-page.js